/* Landbruk · Propuesta C — sin dependencias */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  // Igual que el filtro money de Shopify para los formatos más comunes
  function money(cents) {
    var fmt = theme.moneyFormat || '${{amount_no_decimals}}';
    function group(value, decimals, thousands, decimal) {
      var parts = (value / 100).toFixed(decimals).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', ',');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_with_period_and_space_separator': return group(cents, 2, ' ', '.');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        default: return group(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Menú 2: botón «Todas» ---------- */
  function initTodas() {
    $all('[data-lb-todas]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });
  }
  function openTodas() {
    var btn = $('[data-lb-todas]');
    if (!btn) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (btn.getAttribute('aria-expanded') !== 'true') btn.click();
  }

  /* ---------- Búsqueda con sugerencias ---------- */
  function initSearch() {
    $all('[data-lb-search]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var input = $('input[type="search"]', root);
      var drop = $('[data-lb-search-drop]', root);
      var popular = $('[data-lb-search-popular]', root);
      var results = $('[data-lb-search-results]', root);
      if (!input || !drop) return;
      var timer, blurTimer, lastQ = '';

      function show() { clearTimeout(blurTimer); drop.hidden = false; }
      function hide() { blurTimer = setTimeout(function () { drop.hidden = true; }, 200); }

      function render(q, products) {
        results.innerHTML = '';
        if (!q) { popular.hidden = false; results.hidden = true; return; }
        popular.hidden = true; results.hidden = false;
        var label = document.createElement('span');
        label.className = 'lb-search__label';
        if (!products.length) {
          label.style.textTransform = 'none'; label.style.letterSpacing = '0'; label.style.fontWeight = '400'; label.style.fontSize = '15px';
          label.textContent = 'No encontramos «' + q + '». Prueba con el nombre del cultivo, por ejemplo «lechuga» o «zapallo».';
          results.appendChild(label);
          return;
        }
        label.textContent = 'Productos';
        results.appendChild(label);
        products.forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'lb-search__result';
          a.href = p.url;
          if (p.image) {
            var img = document.createElement('img');
            img.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=96';
            img.alt = ''; img.loading = 'lazy';
            a.appendChild(img);
          } else {
            var ph = document.createElement('span'); ph.className = 'lb-search__thumb'; a.appendChild(ph);
          }
          var t = document.createElement('span');
          t.style.flex = '1'; t.style.minWidth = '0';
          var s = document.createElement('strong'); s.style.display = 'block'; s.style.fontSize = '15px'; s.textContent = p.title;
          t.appendChild(s);
          if (p.type) { var v = document.createElement('span'); v.style.fontSize = '13px'; v.style.color = '#5b6b5e'; v.textContent = p.type; t.appendChild(v); }
          a.appendChild(t);
          var pr = document.createElement('strong'); pr.style.fontSize = '15px'; pr.textContent = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
          a.appendChild(pr);
          results.appendChild(a);
        });
        var all = document.createElement('a');
        all.className = 'lb-search__all';
        all.href = (routes.search_url || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
        all.textContent = 'Ver todos los resultados para «' + q + '» →';
        results.appendChild(all);
      }

      function query(q) {
        lastQ = q;
        if (!q) { render('', []); return; }
        fetch((routes.predictive_search_url || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (q !== lastQ) return;
            var list = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(q, list.map(function (p) {
              return { url: p.url, title: p.title, type: p.type, price: p.price, image: p.image || (p.featured_image && p.featured_image.url) };
            }));
          })
          .catch(function () {});
      }

      input.addEventListener('focus', show);
      input.addEventListener('blur', hide);
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { drop.hidden = true; input.blur(); } });
      input.addEventListener('input', function () {
        show();
        clearTimeout(timer);
        var q = input.value.trim();
        timer = setTimeout(function () { query(q); }, 220);
      });
      $all('[data-lb-q]', root).forEach(function (chip) {
        chip.addEventListener('mousedown', function (e) {
          e.preventDefault();
          input.value = chip.getAttribute('data-lb-q');
          show();
          query(input.value);
        });
      });
    });
  }
  function focusSearch() {
    var input = $('[data-lb-search] input[type="search"]');
    if (!input) { window.location.href = routes.search_url || '/search'; return; }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(function () { input.focus(); }, 250);
  }

  /* ---------- Carro lateral ---------- */
  var drawer, backdrop;
  function drawerEls() {
    drawer = $('[data-lb-drawer]');
    backdrop = $('[data-lb-drawer-backdrop]');
    return !!drawer;
  }
  function openCart() {
    if (!drawerEls()) { window.location.href = routes.cart_url || '/cart'; return; }
    drawer.hidden = false; backdrop.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var close = $('[data-lb-drawer-close]', drawer);
    if (close) close.focus();
  }
  function closeCart() {
    if (!drawerEls()) return;
    drawer.hidden = true; backdrop.hidden = true;
    document.documentElement.style.overflow = '';
  }
  function updateCount(cart) {
    $all('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $all('[data-cart-total]').forEach(function (el) { el.textContent = cart.item_count ? '· ' + money(cart.total_price) : ''; });
  }
  function refreshDrawer() {
    if (!drawerEls()) return Promise.resolve();
    var id = drawer.getAttribute('data-section-id') || 'lb-cart-drawer';
    drawer.classList.add('is-loading');
    return fetch((routes.root_url || '/') + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = new DOMParser().parseFromString(data[id], 'text/html');
        var fresh = $('[data-lb-drawer-inner]', html);
        var current = $('[data-lb-drawer-inner]', drawer);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .finally(function () { drawer.classList.remove('is-loading'); });
  }
  function cartJSON() {
    return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart); return refreshDrawer(); });
  }
  function initDrawer() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : e.target.parentElement;
      if (!t) return;
      if (t.closest('[data-lb-open-cart]')) { e.preventDefault(); openCart(); return; }
      if (t.closest('[data-lb-drawer-close]') || t.closest('[data-lb-drawer-backdrop]')) { e.preventDefault(); closeCart(); return; }
      var plus = t.closest('[data-lb-line-plus]');
      var minus = t.closest('[data-lb-line-minus]');
      var rem = t.closest('[data-lb-line-remove]');
      var btn = plus || minus || rem;
      if (btn) {
        e.preventDefault();
        var key = btn.getAttribute('data-key');
        var q = parseInt(btn.getAttribute('data-qty'), 10) || 0;
        changeLine(key, rem ? 0 : (plus ? q + 1 : Math.max(0, q - 1)));
        return;
      }
      if (t.closest('[data-lb-open-todas]')) { e.preventDefault(); openTodas(); return; }
      if (t.closest('[data-lb-focus-search]')) { e.preventDefault(); focusSearch(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerEls() && !drawer.hidden) closeCart();
    });
  }

  /* ---------- Aviso ---------- */
  var toastTimer;
  function toast(text) {
    var el = $('[data-lb-toast]');
    if (!el) return;
    $('[data-lb-toast-text]', el).textContent = text;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 3200);
  }

  /* ---------- Agregar al carro (AJAX) ---------- */
  function initAddForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !(form.classList.contains('js-lb-add') || form.classList.contains('js-product-form'))) return;
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var label = button && (button.querySelector('.js-btn-label') || button);
      var original = label ? label.textContent : '';
      if (button) button.disabled = true;
      var old = form.querySelector('.lb-error');
      if (old) old.remove();

      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || strings.error);
            return data;
          });
        })
        .then(function (item) {
          if (label) label.textContent = strings.added || 'Agregado ✓';
          if (button) button.classList.add('is-added');
          toast('Agregaste ' + (item.product_title || item.title) + ' al carro');
          return cartJSON().then(function (cart) { updateCount(cart); return refreshDrawer(); });
        })
        .catch(function (err) {
          var box = document.createElement('div');
          box.className = 'lb-error';
          box.setAttribute('role', 'alert');
          box.textContent = err.message || strings.error;
          form.appendChild(box);
          setTimeout(function () { box.remove(); }, 5000);
        })
        .finally(function () {
          setTimeout(function () {
            if (button) { button.disabled = false; button.classList.remove('is-added'); }
            if (label) label.textContent = original;
          }, 2000);
        });
    });
  }

  /* ---------- Ficha de producto ---------- */
  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var jsonEl = $('[data-lb-product-json]', root);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var mainImg = $('[data-lb-main-image] img', root);

    function showThumb(thumb) {
      $all('[data-lb-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      if (thumb && mainImg) {
        mainImg.src = thumb.getAttribute('data-src');
        mainImg.srcset = thumb.getAttribute('data-srcset') || '';
      }
    }
    $all('[data-lb-thumb]', root).forEach(function (t) { t.addEventListener('click', function () { showThumb(t); }); });

    var qty = $('[data-lb-qty] input', root);
    $all('[data-lb-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-lb-qty-step'), 10);
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + step);
      });
    });

    if (!data) return;
    var idInput = $('[data-lb-variant-id]', root);
    var priceEl = $('[data-lb-price]', root);
    var compareEl = $('[data-lb-compare]', root);
    var nameEl = $('[data-lb-variant-name]', root);
    var stockEl = $('[data-lb-stock]', root);
    var addBtn = $('[data-lb-add]', root);
    var addLabel = addBtn && $('.js-btn-label', addBtn);

    function selected() {
      return $all('[data-lb-option]', root).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function onChange() {
      var chosen = selected();
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = strings.unavailable || 'No disponible';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { compareEl.hidden = !(v.compare_at_price > v.price); compareEl.textContent = v.compare_at_price ? money(v.compare_at_price) : ''; }
      if (nameEl) nameEl.textContent = v.title;
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? (strings.addToCart || 'Agregar al carro') : (strings.soldOut || 'Sin stock');
      if (stockEl) stockEl.textContent = !v.available ? (data.soldOutText || '') : (v.inventory !== null ? data.unitsText.replace('__COUNT__', v.inventory) : '');
      if (v.media_id) showThumb($('[data-lb-thumb][data-media-id="' + v.media_id + '"]', root));
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    $all('[data-lb-option] input', root).forEach(function (i) { i.addEventListener('change', onChange); });
  }

  /* ---------- Cronograma de siembra ---------- */
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function initCalendar(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var zonaSel = $('[data-lb-zona]', root);
    var mesSel = $('[data-lb-mes]', root);
    var sum = $('[data-lb-cal-sum]', root);
    if (mesSel && !mesSel.dataset.fixed) mesSel.value = String(new Date().getMonth() + 1);

    function paint() {
      var zona = zonaSel.value;
      var mes = parseInt(mesSel.value, 10);
      var zonaLabel = zonaSel.options[zonaSel.selectedIndex].text;
      var hits = 0;
      $all('[data-lb-cal-head] [data-m]', root).forEach(function (h) { h.classList.toggle('is-now', parseInt(h.getAttribute('data-m'), 10) === mes); });
      $all('[data-lb-crop]', root).forEach(function (row) {
        var list = (row.getAttribute('data-' + zona) || '').split(/[\s,;]+/).map(function (x) { return parseInt(x, 10); });
        var hit = list.indexOf(mes) > -1;
        if (hit) hits++;
        row.classList.toggle('is-hit', hit);
        $all('[data-m]', row).forEach(function (c) {
          var m = parseInt(c.getAttribute('data-m'), 10);
          c.classList.toggle('is-on', list.indexOf(m) > -1);
          c.classList.toggle('is-now', m === mes);
        });
      });
      if (sum) sum.textContent = hits + (hits === 1 ? ' cultivo se siembra' : ' cultivos se siembran') + ' en ' + MESES[mes - 1] + ' en la ' + zonaLabel + '.';
    }
    zonaSel.addEventListener('change', paint);
    mesSel.addEventListener('change', paint);
    paint();
  }

  /* ---------- Ventana de siembra en la ficha ---------- */
  function initWindow(root) {
    var now = new Date().getMonth() + 1;
    $all('[data-m]', root).forEach(function (c) { c.classList.toggle('is-now', parseInt(c.getAttribute('data-m'), 10) === now); });
  }

  /* ---------- WhatsApp: ventanita a mitad de página ---------- */
  function initWhatsapp() {
    var root = $('[data-lb-wa]');
    if (!root) return;
    var bubble = $('[data-lb-wa-bubble]', root);
    var close = $('[data-lb-wa-close]', root);
    if (!bubble) return;
    var KEY = 'lb-wa-cerrado';
    var dismissed = false;
    try { dismissed = window.sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (dismissed) return;
    var shown = false;

    function show() {
      if (shown) return;
      shown = true;
      bubble.hidden = false;
      requestAnimationFrame(function () { bubble.classList.add('is-visible'); });
      window.removeEventListener('scroll', onScroll);
    }
    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      if (window.scrollY / max >= 0.5) show();
    }
    if (document.documentElement.scrollHeight - window.innerHeight < 200) {
      setTimeout(show, 6000);
    } else {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    if (close) {
      close.addEventListener('click', function () {
        bubble.classList.remove('is-visible');
        setTimeout(function () { bubble.hidden = true; }, 300);
        try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {}
      });
    }
  }

  /* ---------- Init ---------- */
  function init(scope) {
    initTodas();
    initSearch();
    $all('[data-lb-product]', scope).forEach(initProduct);
    $all('[data-lb-calendar]', scope).forEach(initCalendar);
    $all('[data-lb-window]', scope).forEach(initWindow);
  }

  initAddForms();
  initDrawer();
  function boot() { init(document); initWhatsapp(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
